import { Flex } from '@chakra-ui/react'
import { TreatmentPlanProvider } from '@context'
import { useExperienceManager } from '@hooks'
import React, { useMemo } from 'react'
import AssistOverlay from '../shared/assist/overlay'
import { ConsiderationsPanel } from './ConsiderationsPanel'
import FinalizeSessionCard from './FinalizeSessionCard'

const SidebarV2 = ({
  client,
  isNoteNull,
  assistOverlayOpen,
  isTxPlanModalOpen,
  setIsTxPlanModalOpen,
  toggleAssistOverlay,
  account,
  session,
  invoice,
  switchToTab
}: {
  client: any
  isNoteNull: boolean
  assistOverlayOpen: boolean
  isTxPlanModalOpen: boolean
  setIsTxPlanModalOpen: (isOpen: boolean) => void
  toggleAssistOverlay: () => void
  account: any
  session: any
  invoice?: any
  switchToTab: (tab: string) => void
}) => {
  const { isDocumentationAutomationEnabled, showRulaUI, showPartnerUI } =
    useExperienceManager()

  const shouldShowConsiderations = useMemo(
    () =>
      isDocumentationAutomationEnabled &&
      !isNoteNull &&
      !showPartnerUI &&
      !assistOverlayOpen,
    [
      isDocumentationAutomationEnabled,
      isNoteNull,
      showPartnerUI,
      assistOverlayOpen
    ]
  )

  const shouldShowAssistOverlay = useMemo(
    () => assistOverlayOpen && !showRulaUI && !showPartnerUI,
    [assistOverlayOpen, showRulaUI, showPartnerUI]
  )

  return (
    <Flex
      data-id="considerations-panel"
      display={{
        base: 'none',
        sm: 'none',
        md: 'block'
      }}
      height="100%"
      borderLeft="1px solid"
      borderColor="pale_gray"
      width="384px"
      maxW="384px"
      flexDirection="column"
      overflowY="auto"
    >
      {shouldShowConsiderations && (
        <Flex justifyContent="center" flexDirection="column">
          <FinalizeSessionCard switchToTab={switchToTab} />
          <ConsiderationsPanel
            setIsTxPlanModalOpen={setIsTxPlanModalOpen}
            isTxPlanModalOpen={isTxPlanModalOpen}
            client={client}
            sessionId={session.id}
            toggleAssistOverlay={toggleAssistOverlay}
          />
        </Flex>
      )}

      {shouldShowAssistOverlay && (
        <TreatmentPlanProvider client={client} toastsEnabled={false}>
          <AssistOverlay
            client={client}
            session={session}
            account={account}
            toggleAssistOverlay={toggleAssistOverlay}
          />
        </TreatmentPlanProvider>
      )}
    </Flex>
  )
}

export default SidebarV2
